import { useIntl } from "react-intl";
import { Container, Tab, Tabs } from "react-bootstrap";
import FamiliesDatabase from "./FamiliesDatabase";
import ProductsDatabase from "./ProductsDatabase";

function Imagedatabase() {
  const intl = useIntl();
  return (
    <Container fluid>
      <Tabs defaultActiveKey={"families"} id="databasesTabs" mountOnEnter>
        <Tab eventKey="families" title={intl.formatMessage({ id: "Families" })}>
          <FamiliesDatabase />
        </Tab>
        <Tab
          eventKey="products"
          title={intl.formatMessage({
            id: "Products",
          })}
        >
          <ProductsDatabase />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default Imagedatabase;
